module.exports = __webpack_public_path__ + "static/media/carousel20.8ad8fe03.jpg";